import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import { useState } from 'react';
import { BiArrowToRight } from 'react-icons/bi';
import { CgClose } from 'react-icons/cg';
import { FaBars, FaMinus, FaPlus } from 'react-icons/fa';
import { SHOW_RIBBON } from 'src/constants';
import { DATALAYER_TYPE, sendDataLayerGlobal } from 'src/utils/datalayer/send-datalayer';
import styled from 'styled-components';
const WidgetSearchFullPage = dynamic(import('src/components/widgets/widget-search-full-page'));

const NavMobile = ({ data }: any) => {
  const router = useRouter();
  // const cid = router.asPath;

  const [toggle, setToggle] = useState(false);
  const [expand, setExpand] = useState({ status: false, key: null });
  function handleToggle(_key: any, _index: any) {
    switch (_key) {
      case 'close':
        setToggle(false);
        setExpand({ key: null, status: false });
        break;
      case 'open':
        setToggle(!toggle);
        break;
      case 'menu':
        setToggle(true);
        setExpand({
          key: _index,
          status: expand?.key === _index ? !expand.status : true
        });
        break;
      default:
        setToggle(false);
        break;
    }
  }

  return (
    <>
      <NavWrapper>
        <div className='nav-mobile'>
          {toggle || expand.status ? (
            <CgClose onClick={() => handleToggle('close', null)} />
          ) : (
            <FaBars
              onClick={() => {
                handleToggle('open', null);
              }}
            />
          )}
        </div>
        {toggle && (
          <nav
            className={`nav-dropdown-mobile ${toggle ? 'visible' : 'invisible'}`}
            style={{
              filter: SHOW_RIBBON === 'true' ? 'grayscale(0.7)' : 'unset'
            }}
          >
            <div className='nav-title'>
              <button onClick={() => handleToggle('close', null)} className='close-btn'>
                <CgClose />
              </button>
              <WidgetSearchFullPage />
            </div>
            {/* ---------------------------------- MENU ---------------------------------- */}
            <ul className={'nav-menu'}>
              <li className='active-menu'>
                <div className='d-flex'>
                  <a
                    href='/'
                    title='หน้าแรก'
                    //! DATALAYER
                    onClick={() =>
                      sendDataLayerGlobal({
                        type: DATALAYER_TYPE.TRACK,
                        router: router?.pathname,
                        section: 'menubar',
                        data: {
                          title: 'หน้าแรก',
                          heading: 'หน้าแรก'
                        }
                      })
                    }
                  >
                    <span className='menu'>home</span>
                  </a>
                </div>
              </li>
              {(toggle || expand.status) &&
                Array.isArray(data) &&
                data.length > 0 &&
                data.map((menu, index) => (
                  <li key={index} className='active-menu'>
                    <div className='d-flex item-menu'>
                      <a
                        href={`/${menu?.link}`}
                        title={menu?.nameTh}
                        //! DATALAYER
                        onClick={() =>
                          sendDataLayerGlobal({
                            type: DATALAYER_TYPE.TRACK,
                            router: router?.pathname,
                            section: 'menubar',
                            data: {
                              title: menu?.nameTh,
                              heading: menu?.nameTh
                            }
                          })
                        }
                      >
                        <span className='menu'>{menu?.nameTh}</span>
                      </a>
                      <div className='drop-item' onClick={() => handleToggle('menu', index)}>
                        {/* ------------------------------- Icon Expand ------------------------------ */}
                        {Array.isArray(menu?.sub) && menu?.sub.length > 0 && (expand?.key === index && expand?.status ? <FaMinus size={16} /> : <FaPlus size={16} />)}
                      </div>
                    </div>
                    {/* --------------------------------- SUBMENU -------------------------------- */}
                    {expand?.key === index && expand?.status && Array.isArray(menu.sub) && (
                      <ul className='nav-sub-menu'>
                        {menu.sub.map((subMenu: any, index: any) => (
                          <li key={index} className='active-sub-menu'>
                            <a
                              href={subMenu?.link}
                              title={subMenu?.nameTh}
                              //! DATALAYER
                              onClick={() =>
                                sendDataLayerGlobal({
                                  type: DATALAYER_TYPE.TRACK,
                                  router: router?.pathname,
                                  section: 'menubar',
                                  data: {
                                    title: subMenu?.nameTh,
                                    heading: `${menu?.nameTh}:${subMenu?.nameTh}`
                                  }
                                })
                              }
                            >
                              <div className='list-sub-menu'>
                                <span className='sub-menu'>{subMenu?.nameTh}</span>
                              </div>
                            </a>
                          </li>
                        ))}
                      </ul>
                    )}
                  </li>
                ))}
              <li className='active-menu'>
                <div className='d-flex item-menu'>
                  <a
                    href='/about-us'
                    aria-label='nav-desktop'
                    title='about'
                    //! DATALAYER
                    onClick={() =>
                      sendDataLayerGlobal({
                        type: DATALAYER_TYPE.TRACK,
                        router: router?.pathname,
                        section: 'menubar',
                        data: {
                          title: 'about',
                          heading: 'about'
                        }
                      })
                    }
                  >
                    <span className='menu'>about</span>
                  </a>
                  <div className='drop-item about'>
                    <BiArrowToRight />
                  </div>
                </div>
              </li>
            </ul>
          </nav>
        )}
      </NavWrapper>
    </>
  );
};

const NavWrapper = styled.div`
  /* start nav mobile */
  ul.nav-menu,
  ul.nav-sub-menu {
    list-style: none;
  }
  .nav-mobile {
    cursor: pointer;
    svg {
      vertical-align: middle;
      font-size: 32px;
      color: #ffffff;
      @media (max-width: 768px) {
        font-size: 18px;
      }
    }
  }
  .invisible {
    visibility: hidden !important;
  }
  nav.nav-dropdown-mobile {
    position: fixed;
    top: 0;
    display: flex;
    flex-direction: column;
    background-color: rgba(0, 0, 0);
    left: 0;
    width: 290px;
    max-width: 100%;
    height: 100vh;
    background-color: #fff;
    z-index: 20;
    box-shadow: 1px 0px 10px 0px rgba(237, 26, 59, 0.3);
    overflow-y: scroll;

    .nav-title {
      display: flex;
      justify-content: space-between;
      padding-right: 10px;
      align-items: center;
      svg {
        font-size: 26px;
        color: #ed1a3b;
      }
    }
    /* ------------------------------- MOBILE : Navigation Menu -------------------------------- */

    .close-btn {
      /* background-color: #ed1a3b; */
      /* position: absolute; */
      background: none;
      top: 10px;
      right: 10px;
      border: none;
      padding: 8px 10px;
      font-size: 16px;
      cursor: pointer;
      svg {
        vertical-align: middle;
        color: #ed1a3b;
        font-size: 20px;
      }
    }

    .img-nav {
      margin: 50px auto 50px auto;
      img {
        width: 100px;
        max-width: 100%;
        height: auto;
      }
    }
    .nav-menu {
      display: flex;
      width: 100%;
      flex-flow: column nowrap;
      padding-inline-start: 0px;
      padding: 0px 20px;
      /* li.active-menu:nth-child(1){
          border-top: 1px solid transparent;
        } */
      li {
        margin: 0px;
        border-top: 1px solid #ed1a3b;
        /* color: white; */
        span {
          padding: 15px 0px;
          /* color: rgb(255, 255, 255); */
          display: flex;
          width: 100%;
          overflow-x: hidden;
          justify-content: space-between;
          align-items: center;
          text-transform: uppercase;
          transition: all 0.5s ease-out 0s;
          &:hover {
            color: #ed1a3b;
          }
        }
        .nav-sub-menu {
          width: 100%;
          padding-left: 20px;
          .list-sub-menu {
            padding-left: 10px;
          }
        }
        &:nth-child(1) {
          border: none;
          padding-top: 0;
        }
      }
      .item-menu {
        justify-content: space-between;
        align-items: center;
        span {
          white-space: pre;
        }
        &:hover {
          a {
            span {
              color: #ed1a3b;
            }
          }
        }
        .drop-item {
          cursor: pointer;
          display: flex;
          width: 100%;
          justify-content: flex-end;
          font-size: 20px;
          &.about {
            svg {
              @media (max-width: 690px) {
                font-size: 20px;
              }
            }
          }
          &:hover {
            svg {
              color: #ed1a3b;
            }
          }
        }
      }
    }
  }
  .logo-img {
    opacity: 0.6;
  }
  /* end nav mobile */
`;

export default NavMobile;
